export default "__VITE_ASSET__Cwx98x3k__"